import {Icon, Layout, SelectItemContent, Text} from '@eitje/web_components'
import {FIRM_STATUS_ICON_MAPPING} from '../cells/firm_status_icon_mapping'

export const FirmStatusFilterItem = ({item, checkboxProps}) => {
	const {id, t} = item
	const {color, icon} = FIRM_STATUS_ICON_MAPPING[id] || {}

	return (
		<Layout checked gap={16}>
			<SelectItemContent checkboxProps={checkboxProps}>
				<Icon name={icon} fill={color} />
				<Text t={t} />
			</SelectItemContent>
		</Layout>
	)
}
